import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ProductType } from "src/app/core/product/enums";
import { AppService } from "src/app/core/app/app.service";
import { Router } from "@angular/router";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { CalendarPickerComponent } from "src/app/shared/components/forms/calendar-picker/calendar-picker.component";

import { CitySummary } from "src/app/core/order/models/city-summary.model";
import { VenueSummary } from "src/app/core/order/models/venue-summary.model";
import {
  TimeframeFilter,
  CustomTimeframeFilter
} from "src/app/core/timeframe/timeframes";

@Component({
  selector: "ll-filter-orders",
  templateUrl: "./filter-orders.component.html",
  styleUrls: ["./filter-orders.component.scss"]
})
export class FilterOrdersComponent implements OnInit {
  objectKeys = Object.keys;
  modalRef: MDBModalRef;
  mobile: boolean;

  constructor(
    private modalService: MDBModalService,
    public app: AppService,
    private router: Router
  ) {}

  ngOnInit() {
    this.mobile = window.innerWidth < 700;
  }

  public get cities(): CitySummary[] {
    return this.app.state.orderFilterCities;
  }
  public get venues(): VenueSummary[] {
    return this.app.state.orderFilterVenues;
  }
  public get timeframes(): TimeframeFilter[] {
    return this.app.state.orderFilterTimeframes;
  }

  public setCityFilter(data: CitySummary) {
    this.app.state.onOrderFilterCitySelected(data);
  }
  public setVenueFilter(data: VenueSummary) {
    this.app.state.onOrderFilterVenueSelected(data);
  }

  public setProductTypeFilter(data: ProductType) {
    this.app.state.onOrderFilterProductTypeSelected(data);
  }
  public setTimeframeFilter(data: TimeframeFilter) {
    this.app.state.onOrderFilterTimeframeSelected(data);
  }
  public setRedeemedFilter() {
    this.app.state.onOrderFilterRedeemTogglePressed();
  }

  public setOutstandingFilter() {
    this.app.state.onOrderFilterOutstandingTogglePressed();
  }
  public get currentCity(): CitySummary {
    return this.app.state.orderFilterCurrentCity;
  }
  public get currentVenue(): VenueSummary {
    return this.app.state.orderFilterCurrentVenue;
  }
  public get currentProductType(): ProductType {
    return this.app.state.orderFilterCurrentProductType;
  }
  public get currentTimeframe(): TimeframeFilter {
    return this.app.state.orderFilterCurrentTimeframe;
  }
  public get showRedeemed() {
    return this.app.state.orderFilterShowRedeemed;
  }

  public get showOutstanding() {
    return this.app.state.orderFilterShowOutstanding;
  }
  public get cityFilterValue(): String {
    return this.currentCity == null
      ? "All"
      : this.currentCity.name + ", " + this.currentCity.state;
  }

  get isAdmin() {
    return !this.router.url.includes("venue");
  }

  public get productTypes(): ProductType[] {
    return [
      ProductType.Cover,
      ProductType.Drink,
      ProductType.LineSkip,
      ProductType.Other,
      ProductType.Menu,
      ProductType.Ticket
    ];
  }
  productMask(type: ProductType) {
    switch (type) {
      case ProductType.Other:
        return "Other";
      case ProductType.LineSkip:
        return "LineSkip";
      case ProductType.Cover:
        return "Cover";
      case ProductType.Drink:
        return "Drink";
      case ProductType.Menu:
        return "Menu";
      case ProductType.Ticket:
        return "Ticket";
      default:
        return "All";
    }
  }

  init() {}

  changeTimeframe(tf: TimeframeFilter) {
    if (tf.label == "Custom Date") this.customTimeframe();
    else {
      this.app.state.onOrderFilterTimeframeSelected(tf);
    }
  }

  public get showRedeemFilter(): boolean {
    return this.router.url.includes("orders");
  }

  customTimeframe() {
    this.modalRef = this.modalService.show(CalendarPickerComponent, {
      ignoreBackdropClick: true,
      class: "modal-sm modal-dialog-centered",
      containerClass: "",
      animated: true,
      data: {
        header: "Custom Timeframe",
        subheader: "Please provide a custom timeframe.",
        save: this.saveDate
      }
    });
  }
  saveDate(begin: Date, end: Date) {
    this.app.state.onOrderFilterTimeframeSelected(
      new CustomTimeframeFilter(begin, end)
    );
  }
  /** END TIMEFRAME FILTER */
}
